export const NOTIFICATION_ADD = 'NOTIFICATION_ADD';

export const NOTIFICATION_REMOVE = 'NOTIFICATION_REMOVE';
